// @flow

import { getJSON } from 'redux-api-middleware';
import { I18n } from '@shopify/react-i18n';
import { processRes } from 'src/helpers/actions-helper';

import apiService from 'src/services/api-service';

import {
  INSTALL_APP_REQUEST,
  INSTALL_APP_SUCCESS,
  INSTALL_APP_FAILURE,
  GET_INSTALL_STATUS_REQUEST,
  GET_INSTALL_STATUS_SUCCESS,
  GET_INSTALL_STATUS_FAILURE,
  UPDATE_INSTALLATION_STATUS_REQUEST,
  UPDATE_INSTALLATION_STATUS_SUCCESS,
  UPDATE_INSTALLATION_STATUS_FAILURE,
  UPDATE_INSTALLATION_KYC_STATUS_REQUEST,
  UPDATE_INSTALLATION_KYC_STATUS_SUCCESS,
  UPDATE_INSTALLATION_KYC_STATUS_FAILURE,
  ADD_DEMOGRAPHIC_FAILURE,
  ADD_DEMOGRAPHIC_REQUEST,
  ADD_DEMOGRAPHIC_SUCCESS,
  ALERT_SLOW_INSTALLATION_REQUEST,
  ALERT_SLOW_INSTALLATION_SUCCESS,
  ALERT_SLOW_INSTALLATION_FAILURE
} from 'stores/flow-type/install.type';

/**
 * call to install app
 * @return {object} The RSAA object for API middleware
 */
export const installApp = (queries: Object, i18n: I18n) => {
  return apiService.sendRequest('admin-v3.install.post-shopify-install', { queries }, [
    INSTALL_APP_REQUEST,
    {
      type: INSTALL_APP_SUCCESS,
      payload: async (action, state, res) => {
        const data = await getJSON(res);

        return { data };
      }
    },
    {
      type: INSTALL_APP_FAILURE,
      payload: async (action, state, res) =>
        await processRes(
          res,
          'error',
          i18n.translate('AdminHTML.Installation.Actions.installApp'),
          i18n
        )
    }
  ]);
};

/**
 * call to get status of installation
 * @return {object} The RSAA object for API middleware
 */
export const getInstallStatus = (i18n: I18n, payload = {}) => {
  const routePath = 'sip-v3.install.get-install-status';

  return apiService.sendRequest(routePath, payload, [
    GET_INSTALL_STATUS_REQUEST,
    {
      type: GET_INSTALL_STATUS_SUCCESS,
      payload: async (action, state, res) => {
        const data = await getJSON(res);

        return { data };
      }
    },
    {
      type: GET_INSTALL_STATUS_FAILURE,
      payload: async (action, state, res) =>
        await processRes(
          res,
          'error',
          i18n.translate('AdminHTML.Installation.Actions.getInstallStatus'),
          i18n
        )
    }
  ]);
};

/**
 * call to install app
 * @return {object} The RSAA object for API middleware
 */
export const updateInstallationStatus = (status: string) => {
  const body = { status };
  return apiService.sendRequest('sip-v3.install.update-install-status', { body }, [
    UPDATE_INSTALLATION_STATUS_REQUEST,
    {
      type: UPDATE_INSTALLATION_STATUS_SUCCESS,
      payload: async (action, state, res) => {
        const data = await getJSON(res);

        return { data };
      }
    },
    {
      type: UPDATE_INSTALLATION_STATUS_FAILURE,
      payload: async (action, state, res) => {
        const data = await getJSON(res);

        return { data };
      }
    }
  ]);
};

/**
 * call to install app
 * @return {object} The RSAA object for API middleware
 */
export const updateInstallationKYCStatus = data => {
  const body = data;
  return apiService.sendRequest('admin-v3.install.update-install-kyc-status', { body }, [
    UPDATE_INSTALLATION_KYC_STATUS_REQUEST,
    {
      type: UPDATE_INSTALLATION_KYC_STATUS_SUCCESS,
      payload: async (action, state, res) => {
        const data = await getJSON(res);
        return { data };
      }
    },
    {
      type: UPDATE_INSTALLATION_KYC_STATUS_FAILURE,
      payload: async (action, state, res) => {
        const data = await getJSON(res);
        return { data };
      }
    }
  ]);
};

export const addDemographic = body => {
  return apiService.sendRequest('admin-v3.demographic.update-demographic', { body }, [
    ADD_DEMOGRAPHIC_REQUEST,
    {
      type: ADD_DEMOGRAPHIC_SUCCESS,
      payload: async (action, state, res) => {
        const data = await getJSON(res);
        return { data };
      }
    },
    {
      type: ADD_DEMOGRAPHIC_FAILURE,
      payload: async (action, state, res) => {
        const data = await getJSON(res);
        return { data };
      }
    }
  ]);
};

/**
 * Alert when user stay in initialization page too long
 * @param {*} body
 * @returns
 */
export const alertSlowInstallation = body => {
  return apiService.sendRequest('sip-v3.install.alert-slow-installation', { body }, [
    ALERT_SLOW_INSTALLATION_REQUEST,
    {
      type: ALERT_SLOW_INSTALLATION_SUCCESS,
      payload: async (action, state, res) => {
        const data = await getJSON(res);
        return { data };
      }
    },
    {
      type: ALERT_SLOW_INSTALLATION_FAILURE,
      payload: async (action, state, res) => {
        const data = await getJSON(res);
        return { data };
      }
    }
  ]);
};
